import { Injector, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService, UserService } from '../services';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { awaitUserLookup, isMemberOrAuthenticated } from './await-user-lookup';

export const redirectIfAuthenticated = (): Observable<boolean | any> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const cookieService = inject(CookieService);
  const userService = inject(UserService);
  const injector = inject(Injector);

  // The user lookup needs the browser's cookies; the server renders the home page for everyone.
  if (isPlatformServer(inject(PLATFORM_ID))) {
    return of(true);
  }

  const hasToken = authService.getAuthToken() !== '';
  const hasValidPdSession = !!cookieService.get('PD-H-SESSION-ID')?.match('^1');

  // If user is authenticated, check if they're a member before redirecting to dashboard
  if (hasToken && hasValidPdSession) {
    // A failed or empty lookup shows the home page; the app shell surfaces the error to the user.
    return awaitUserLookup(userService, injector).pipe(
      map(({ user }) => (isMemberOrAuthenticated(user) ? router.createUrlTree(['/dashboard-landing']) : true))
    );
  }

  return of(true);
};
